module.exports = __webpack_public_path__ + "img/management-team.a3fa81e8.png";